import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { fetchDeleteSellingItem } from '../../ducks/sales.duck';

export const useSellingDelete = () => {
  const dispatch = useDispatch();

  const handleSellingDelete = useCallback(
    (id: number) => (e: React.MouseEvent<HTMLButtonElement>) => {
      e?.stopPropagation();
      dispatch(fetchDeleteSellingItem(id));
    },
    [dispatch]
  );

  return {
    handleSellingDelete,
  };
};
